import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import Zoom from 'react-reveal/Zoom';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import Randomizer from '../components/randomizer';
import OcTanner from '../assets/ads/octanner.jpg';
import Harmons from '../assets/ads/harmons.jpg';
import LivingPlanet from '../assets/ads/living-planet.jpg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "carmina-burana-with-glass-pieces",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#carmina-burana-with-glass-pieces",
        "aria-label": "carmina burana with glass pieces permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Carmina Burana with Glass Pieces`}</h1>
    <h2 {...{
      "id": "ballet-west",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#ballet-west",
        "aria-label": "ballet west permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Ballet West`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`All information was published as of March 28th, 2022`}</p>
    </blockquote>
    <Link to="/carmina-burana" mdxType="Link">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAADAv/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABSnoeNLtaM80GpVxJ/8QAGhAAAwEBAQEAAAAAAAAAAAAAAQISABEDIf/aAAgBAQABBQII9SNAz1I9D3uIsSAe4p862QUv/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8BKf/EABYRAQEBAAAAAAAAAAAAAAAAAAAREP/aAAgBAgEBPwHIj//EACEQAAAFAgcAAAAAAAAAAAAAAAABAiExEBEDEiIyUXGh/9oACAEBAAY/AjjLXS3Yw1WZUnR44CbRRhs9FzYf/8QAHRAAAgMAAgMAAAAAAAAAAAAAAREAIUExURBhkf/aAAgBAQABPyENwPED1Tg0udIYtwRSnIRxACqAIOf6hHqtxngvU+ypgbOaxJdNz//aAAwDAQACAAMAAAAQv+aP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAwEBPxDIKj//xAAXEQEBAQEAAAAAAAAAAAAAAAAAEQEh/9oACAECAQE/EO6qlv/EAB4QAQACAgIDAQAAAAAAAAAAAAEAESExUWFBkbGB/9oACAEBAAE/EMsMDnXlZSWsLC8pzAWLbjXUSS2CxhDZ+nmLk2icLdPCxO1DgalyZieHvrqAymLs6NmPcpzEx3xlL3UTaOjGPybotKfap//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/8ac56/carmina-cover.webp 240w", "/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/d3be9/carmina-cover.webp 480w", "/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/87ca7/carmina-cover.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/09b79/carmina-cover.jpg 240w", "/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/7cc5e/carmina-cover.jpg 480w", "/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/1a144/carmina-cover.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/carmina-2022/static/e4b7c35b8d77ea226a67d84e95ed0fe5/1a144/carmina-cover.jpg",
              "alt": "Carmina Burana with Glass Pieces cover",
              "title": "Carmina Burana with Glass Pieces cover",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </Link>
    <blockquote>
      <p parentName="blockquote">{`📱 Please use the menu to explore our mobile friendly program.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`📖 If you prefer a traditional “page turning” format as with print publications, `}<a parentName="p" {...{
          "href": "/carmina-2022/digital-program"
        }}>{`please click here`}</a>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "quick-navigation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#quick-navigation",
        "aria-label": "quick navigation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Quick Navigation`}</h3>
    <section className="home-list">
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/carmina-burana">
    Carmina Burana
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/glass-pieces">
    Glass Pieces
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/sponsors">
    Sponsors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/ballet-west-company">
    Ballet West
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/board-of-directors">
    Board of Directors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/from-the-artistic-director">
    From the Artistic Director
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/casting">
    Casting
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/wellness-partners">
    Wellness Partners
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/profiles">
    Profiles
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/digital-program">
    Digital Program
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/corporate-foundation-and-government-support">
    Corporate, Foundation, and Government Support
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/individual-donors">
    Individual Donors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/ballet-west-guild">
    Ballet West Guild
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/house-rules">
    House Rules
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/carmina-2022/ballet-west-staff">
    Ballet West Staff
  </a>
      </Zoom>
    </section>
    <br />
    <br />
    <OutboundLink href="https://www.americafirst.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgUD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAD/9oADAMBAAIQAxAAAAFrLeWFEkrQorfTPuJA/wD/xAAgEAABAwMFAQAAAAAAAAAAAAACAAEDERIxBBATFCEi/9oACAEBAAEFAsQ9fwwtKtdPyspPomlVwq4dmKjPn//EABcRAAMBAAAAAAAAAAAAAAAAAAABEhD/2gAIAQMBAT8BeWWf/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQEhP/2gAIAQIBAT8BUZlD/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAEREBIgMjFygv/aAAgBAQAGPwJ9WbEXHk0JGopxh//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESFhMYGRcaH/2gAIAQEAAT8haRA5a9QWeWiN02PyVI1lsB9gUtCp8fZpQccTGYOorTP/2gAMAwEAAgADAAAAEGflPv/EABgRAAMBAQAAAAAAAAAAAAAAAAABERBR/9oACAEDAQE/EMN7IVw//8QAGBEAAgMAAAAAAAAAAAAAAAAAABEQMVH/2gAIAQIBAT8QgisXT//EAB8QAQEAAgIBBQAAAAAAAAAAAAERACExQXFRYYGRof/aAAgBAQABPxBOmClCwjgxaTyeuJluQBXRsxkjWYUEhIpHj2xLAEDY6x28IKkeM37PqxR5fkwjbpnow87+5ogK9EM//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/79b140f335c61509ca20d966e214f58a/8ac56/afcu.webp 240w", "/carmina-2022/static/79b140f335c61509ca20d966e214f58a/d3be9/afcu.webp 480w", "/carmina-2022/static/79b140f335c61509ca20d966e214f58a/87ca7/afcu.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/79b140f335c61509ca20d966e214f58a/09b79/afcu.jpg 240w", "/carmina-2022/static/79b140f335c61509ca20d966e214f58a/7cc5e/afcu.jpg 480w", "/carmina-2022/static/79b140f335c61509ca20d966e214f58a/1a144/afcu.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/carmina-2022/static/79b140f335c61509ca20d966e214f58a/1a144/afcu.jpg",
              "alt": "America First Credit Union",
              "title": "America First Credit Union",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>
    <OutboundLink href="https://www.bmwutah.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAECAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAY0YFjDXVdTooZX/xAAdEAACAgEFAAAAAAAAAAAAAAABAgADEBESEyFB/9oACAEBAAEFAgiiba4K0I4VhqWDRR7nvH//xAAXEQADAQAAAAAAAAAAAAAAAAAAARIQ/9oACAEDAQE/AYJW/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAASABD/2gAIAQIBAT8Bct//xAAeEAABBAEFAAAAAAAAAAAAAAAAAQIRITEQEiAykf/aAAgBAQAGPwK1Sjs0yhc2UySNi+cc6f/EAB4QAAMAAgEFAAAAAAAAAAAAAAABESExEEFhcaHx/9oACAEBAAE/IandiGwsEVm3XqEtnlRYHuDboyLXE+AtZdP/2gAMAwEAAgADAAAAEJwhMP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QC//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxAW/wD/xAAdEAEBAAICAwEAAAAAAAAAAAABEQAhMVFhkaFx/9oACAEBAAE/EAoPY8fu8AMKFd7wNKe2YgluCtfmKlINWJ4wIAc7X1MByS5fL2Zc3EFdvoxgxm9aaMKRR3M//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/8ac56/bmw.webp 240w", "/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/d3be9/bmw.webp 480w", "/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/87ca7/bmw.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/09b79/bmw.jpg 240w", "/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/7cc5e/bmw.jpg 480w", "/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/1a144/bmw.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/carmina-2022/static/bc7e59cd8041199560947f97d7f8c1a4/1a144/bmw.jpg",
              "alt": "BMW of Murray and Pleasant Grove",
              "title": "BMW of Murray and Pleasant Grove",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>
    <OutboundLink href="https://www.parkcitygalleryassociation.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAFnGKZ1mSIlc6KoDYf/xAAdEAACAgIDAQAAAAAAAAAAAAABAgMRABIEFCEz/9oACAEBAAEFAinljBGMk5FT7jZ2ppAW5Udlm9L/AHgc69txn//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAECAQE/ASP/xAAdEAACAQQDAAAAAAAAAAAAAAAAARECEiExEFGR/9oACAEBAAY/Ap0dmWWZhc1IqZplxY4hGI8P/8QAHBABAAMAAgMAAAAAAAAAAAAAAQARIUFhMVGB/9oACAEBAAE/IaEbDsx117lK9nqFmo7XMLQK0HMwIQHVogrr8nMCs8QPVN8B41F6Yx//2gAMAwEAAgADAAAAELf7AP/EABYRAQEBAAAAAAAAAAAAAAAAABARMf/aAAgBAwEBPxCmH//EABURAQEAAAAAAAAAAAAAAAAAABEQ/9oACAECAQE/EBFn/8QAHRAAAgMBAAMBAAAAAAAAAAAAAREAITFBUWGB0f/aAAgBAQABPxDq6CAz7CkSAyAAA+MhCPZcQmVqLZBz1yEBw2G7bXNg8GCEIgghKpefkFy0ogCcofKhJdjQfqGDoO+DcfsydY7aN7FFW6RfvZ//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/8ac56/pc-gallery.webp 240w", "/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/d3be9/pc-gallery.webp 480w", "/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/87ca7/pc-gallery.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/09b79/pc-gallery.jpg 240w", "/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/7cc5e/pc-gallery.jpg 480w", "/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/1a144/pc-gallery.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/carmina-2022/static/9692f99c6dfffec55f1e251b6db262ad/1a144/pc-gallery.jpg",
              "alt": "Park City Gallery Association",
              "title": "Park City Gallery Association",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      